export default "__VITE_ASSET__BA08Qr3x__"